<template>
  <div class="dsf-ac-style-spebox">
    <grid
      ref="dsfDatagrid"
      :demo="demo"
      :hasLoad="hasLoad"
      :hasRefresh="hasRefresh"
      :http-param="childform"
      :background-color="'#fff'"
      :limit="limit"
      :padding="padding"
      style="height: 100%">
      <div slot="default" slot-scope="sditem" :key="sditem.data['nc_ztb_mhzxdata.nc_zyb_id']">
        <div class="citem" @click="tosep(sditem)">
          <div class="imgbox">
            <van-image :src="setImg(sditem.data)" fit="full" :width="'100%'" :height="'100%'">
              <template v-slot:loading>
                <van-loading type="spinner" size="20" />
              </template>
              <template v-slot:error>
                <img :src="require('_teas/assets/styles/themes/img/file-read-18688.png')" style="width: 100%; height: 100%" />
              </template>
            </van-image>
            <div class="tnum ds_font8">
              <span>
                {{ sditem.data["nc_ztb_mhzxdata.pxrq_sdate"] }}至{{sditem.data["nc_ztb_mhzxdata.pxrq_edate"]}}
              </span>
            </div>
          </div>
          <div class="rcontent">
            <div class="toptitle ds_font5_m">
              <span v-if="sditem.data['nc_ztb_mhzxdata.sfbx'] == 1" class="s2 ds_font8">必修</span>
              <p class="ell2">{{ sditem.data["nc_ztb_mhzxdata.title"] }}</p>
            </div>
            <div class="cencontent ds_font8">
              <p>
                必修: {{ sditem.data["nc_ztb_mhzxdata.bxryms"] || 0 }}门
                {{ sditem.data["nc_ztb_mhzxdata.bxryxs"] || 0 }}学时
              </p>
              <p>
                选修: {{ sditem.data["nc_ztb_mhzxdata.xxryms"] || 0 }}门
                {{ sditem.data["nc_ztb_mhzxdata.xxryxs"] || 0 }}学时
              </p>
              <p>学员人数: {{ sditem.data["nc_ztb_mhzxdata.studentnum"] || 0 }}</p>
            </div>
            <div
              class="rechart rechartno"
              :class="{
                rechartyes: sditem.data['nc_ztb_mhzxdata.sfwc_value'] == 2,
              }"
              v-if="sditem.data['nc_ztb_mhzxdata.sfwc_value'] !== 1"></div>
          </div>
        </div>
      </div>
    </grid>
  </div>
</template>

<script>
import grid from "./oldGrid";

const demo = [
  {
    "nc_ztb_mhzxdata.syts": 4,
    "nc_ztb_mhzxdata.bxryxs": "0.0",
    "nc_ztb_mhzxdata.xxryms": "2",
    "nc_ztb_mhzxdata.xbdw": null,
    "nc_ztb_mhzxdata.title": "测试课程时间",
    "nc_ztb_mhzxdata.bxryms": "0",
    "nc_ztb_mhzxdata.ztblx_value": "2",
    "nc_ztb_mhzxdata.xxsj": null,
    "nc_ztb_mhzxdata.studentnum": 1,
    "nc_ztb_mhzxdata.is_xly": "0",
    "nc_ztb_mhzxdata.pxrq_sdate": "01-21",
    "nc_ztb_mhzxdata.zbdw": null,
    "nc_ztb_mhzxdata.cover": null,
    "nc_ztb_mhzxdata.state": 4,
    "nc_ztb_mhzxdata.bmxz_value": "0",
    "nc_ztb_mhzxdata.nc_zyb_id": "8183d3efed3a42769a0b2da29143a07f",
    "nc_ztb_mhzxdata.xxryxs": "1.0",
    "nc_ztb_mhzxdata.sfbx": 0,
    "nc_ztb_mhzxdata.pxrq_edate": "02-06",
    "nc_ztb_mhzxdata.sfwc_value": 1
  },
  {
    "nc_ztb_mhzxdata.syts": 16,
    "nc_ztb_mhzxdata.bxryxs": "0.0",
    "nc_ztb_mhzxdata.xxryms": "3",
    "nc_ztb_mhzxdata.xbdw": null,
    "nc_ztb_mhzxdata.title": "测试专题班0201",
    "nc_ztb_mhzxdata.bxryms": "0",
    "nc_ztb_mhzxdata.ztblx_value": "1",
    "nc_ztb_mhzxdata.xxsj": "2021-02-01 18:36:16",
    "nc_ztb_mhzxdata.studentnum": 3,
    "nc_ztb_mhzxdata.is_xly": "0",
    "nc_ztb_mhzxdata.pxrq_sdate": "02-01",
    "nc_ztb_mhzxdata.zbdw": null,
    "nc_ztb_mhzxdata.cover": null,
    "nc_ztb_mhzxdata.state": 2,
    "nc_ztb_mhzxdata.bmxz_value": "0",
    "nc_ztb_mhzxdata.nc_zyb_id": "1734db7781e64885b588419d17daada1",
    "nc_ztb_mhzxdata.xxryxs": "1.5",
    "nc_ztb_mhzxdata.sfbx": 0,
    "nc_ztb_mhzxdata.pxrq_edate": "02-18",
    "nc_ztb_mhzxdata.sfwc_value": 1
  },
  {
    "nc_ztb_mhzxdata.syts": 31,
    "nc_ztb_mhzxdata.bxryxs": "3.0",
    "nc_ztb_mhzxdata.xxryms": "2",
    "nc_ztb_mhzxdata.xbdw": null,
    "nc_ztb_mhzxdata.title": "考试模块-训练营",
    "nc_ztb_mhzxdata.bxryms": "3",
    "nc_ztb_mhzxdata.ztblx_value": "1",
    "nc_ztb_mhzxdata.xxsj": "2021-02-02 10:38:11",
    "nc_ztb_mhzxdata.studentnum": 12,
    "nc_ztb_mhzxdata.is_xly": "1",
    "nc_ztb_mhzxdata.pxrq_sdate": "12-31",
    "nc_ztb_mhzxdata.zbdw": null,
    "nc_ztb_mhzxdata.cover":
      '[{"originalFileName":"党的最高理想和最终目标是实现共产主义.jpg","name":"党的最高理想和最终目标是实现共产主义","suffix":"jpg","size":32037,"contentType":"application/octet-stream","relativePath":"/upload/files/20201229/fdd1826701cb4f4f9f26f10803db9931.jpg","absolutePath":"http://61.243.3.22:8088/dsfa/upload/files/20201229/fdd1826701cb4f4f9f26f10803db9931.jpg","uploadDate":"2020-12-29 11:07:41","id":"a820423caf0e4ca99fb141bff63b3583"}]',
    "nc_ztb_mhzxdata.state": 2,
    "nc_ztb_mhzxdata.bmxz_value": "0",
    "nc_ztb_mhzxdata.nc_zyb_id": "f87387b2a6cb4162b5905982ca58fef3",
    "nc_ztb_mhzxdata.xxryxs": "1.0",
    "nc_ztb_mhzxdata.sfbx": 0,
    "nc_ztb_mhzxdata.pxrq_edate": "03-05",
    "nc_ztb_mhzxdata.sfwc_value": 1
  }
];

export default {
  name: "inlearningSpecial",
  props: {
    childform: {
      type: Object,
      default() {
        return {};
      }
    },
    limit: {
      type: Number,
      default: 9
    },
    hasLoad: {
      type: Boolean,
      default: true,
      desc: "是否有上拉加载"
    },
    hasRefresh: {
      type: Boolean,
      default: true,
      desc: "是否有下拉刷新"
    },
    padding: {
      type: Array,
      default() {
        return [0, 0, 0, 15];
      }
    }
  },
  components: {
    grid
  },
  data() {
    return {
      demo: []
    };
  },
  created: function () {
    this.demo = demo;
  },

  methods: {
    setImg(data) {
      let cover = data["nc_ztb_mhzxdata.cover"];
      if (cover) {
        cover = dsf.url.getWebPath(JSON.parse(cover)[0]["relativePath"]);
      }
      return cover || "/";
    },
    reset() {
      this.$refs.dsfDatagrid.query();
    },
    tosep(item) {
      if (this.isDesign) return;
      let sourceUrl = "specialContent/DetailContent";
      const id = item.data["nc_ztb_mhzxdata.nc_zyb_id"];
      const type = item.data["nc_ztb_mhzxdata.is_xly"];
      if (type == 1) sourceUrl = "trainingCamp";
      // this.$router.push({ path: sourceUrl + id });
      this.$router.push({
        path: `/mobile/nc/recommendFile/mobile-specilaDetail?id=${id}`
      });
      //  #/mobile/nc/recommendFile/mobile-specilaDetail?id=2f43607cacea42b1846ff9a77fe5e752
      // this.$open({ url: `${location.origin}/dsfa_nc/nc/mobile/dist/webmobile/index.html#/${sourceUrl}/${id}`, state: 4 });
    }
  }
};
</script>